
import { ForecastModel } from "@/lib/types";

export const sampleForecastModels: ForecastModel[] = [
  {
    id: "model-1",
    name: "Base Case Projection",
    tenementId: "tenement-1",
    startYear: 2023,
    endYear: 2028,
    mineralPrice: 1750,
    productionRampUp: [0.1, 0.2, 0.3, 0.3, 0.1],
    operatingCosts: [500000, 750000, 1000000, 1000000, 800000],
    capitalCosts: [2000000, 1000000, 500000, 200000, 100000],
    discountRate: 0.1,
    projectionData: [
      { year: 2023, production: 10000, revenue: 17500000, costs: 500000, cashFlow: 17000000, discountedCashFlow: 15454545, npv: 15454545 },
      { year: 2024, production: 20000, revenue: 35000000, costs: 750000, cashFlow: 34250000, discountedCashFlow: 28305785, npv: 43760330 },
      { year: 2025, production: 30000, revenue: 52500000, costs: 1000000, cashFlow: 51500000, discountedCashFlow: 38722458, npv: 82482788 },
      { year: 2026, production: 30000, revenue: 52500000, costs: 1000000, cashFlow: 51500000, discountedCashFlow: 35202235, npv: 117685023 },
      { year: 2027, production: 10000, revenue: 17500000, costs: 800000, cashFlow: 16700000, discountedCashFlow: 10368408, npv: 128053431 },
    ],
    isPreRevenue: false,
    budgetDetails: {
      keyExpensesBreakdown: {
        "Labor": 1200000,
        "Equipment": 800000,
        "Maintenance": 500000,
        "Energy": 300000,
        "Materials": 250000,
        "Permits": 100000,
        "Insurance": 80000,
        "Other": 170000
      },
      capitalExpenditureDetails: {
        "Infrastructure": 1200000,
        "Processing Plant": 1500000,
        "Mining Equipment": 800000,
        "Environmental Controls": 200000,
        "Exploration": 100000
      },
      contingencyReserve: 500000
    }
  },
  {
    id: "model-2",
    name: "Optimistic Scenario",
    tenementId: "tenement-1",
    startYear: 2023,
    endYear: 2028,
    mineralPrice: 2000,
    productionRampUp: [0.15, 0.25, 0.35, 0.25],
    operatingCosts: [450000, 700000, 900000, 750000],
    capitalCosts: [1800000, 900000, 400000, 150000],
    discountRate: 0.08,
    projectionData: [
      { year: 2023, production: 15000, revenue: 30000000, costs: 450000, cashFlow: 29550000, discountedCashFlow: 27361111, npv: 27361111 },
      { year: 2024, production: 25000, revenue: 50000000, costs: 700000, cashFlow: 49300000, discountedCashFlow: 42207385, npv: 69568496 },
      { year: 2025, production: 35000, revenue: 70000000, costs: 900000, cashFlow: 69100000, discountedCashFlow: 54756695, npv: 124325191 },
      { year: 2026, production: 25000, revenue: 50000000, costs: 750000, cashFlow: 49250000, discountedCashFlow: 36117925, npv: 160443116 },
    ],
    isPreRevenue: false,
    budgetDetails: {
      keyExpensesBreakdown: {
        "Labor": 1000000,
        "Equipment": 700000,
        "Maintenance": 450000,
        "Energy": 250000,
        "Materials": 200000,
        "Permits": 80000,
        "Insurance": 70000,
        "Other": 150000
      },
      capitalExpenditureDetails: {
        "Infrastructure": 1000000,
        "Processing Plant": 1300000,
        "Mining Equipment": 700000,
        "Environmental Controls": 180000,
        "Exploration": 70000
      },
      contingencyReserve: 400000
    }
  },
  {
    id: "model-3",
    name: "Pre-Revenue Exploration",
    tenementId: "tenement-2",
    startYear: 2023,
    endYear: 2025,
    mineralPrice: 1800,
    productionRampUp: [0, 0, 0],
    operatingCosts: [200000, 300000, 400000],
    capitalCosts: [500000, 800000, 1200000],
    discountRate: 0.12,
    projectionData: [
      { year: 2023, production: 0, revenue: 0, costs: 200000, cashFlow: -200000, discountedCashFlow: -178571, npv: -178571 },
      { year: 2024, production: 0, revenue: 0, costs: 300000, cashFlow: -300000, discountedCashFlow: -239469, npv: -418040 },
      { year: 2025, production: 0, revenue: 0, costs: 400000, cashFlow: -400000, discountedCashFlow: -285177, npv: -703217 },
    ],
    isPreRevenue: true,
    roiMetrics: {
      roi: -100,
      burnRate: 33333,
      dcf: -703217,
      dilutionImpact: 15,
      breakEvenPoint: 0
    },
    budgetDetails: {
      keyExpensesBreakdown: {
        "Exploration": 500000,
        "Geological Studies": 200000,
        "Permitting": 100000,
        "Admin": 100000
      },
      capitalExpenditureDetails: {
        "Exploration Equipment": 300000,
        "Land Acquisition": 1800000,
        "Initial Site Work": 400000
      },
      contingencyReserve: 200000
    },
    milestoneProjections: [
      {
        name: "Resource Definition",
        date: "2024-06",
        description: "Complete initial resource definition",
        valueImpact: 20,
        valueAfter: 5000000
      },
      {
        name: "Feasibility Study",
        date: "2025-12",
        description: "Complete feasibility study",
        valueImpact: 40,
        valueAfter: 7000000
      }
    ]
  }
];
